/**
 * SizilPro — useAuth
 * Convenience hook — wraps authStore selectors.
 * Import this in components rather than calling useAuthStore directly.
 */

import { useAuthStore } from "@/store/authStore";

export function useAuth() {
  const user     = useAuthStore((s) => s.user);
  const userId   = useAuthStore((s) => s.userId);
  const clientId = useAuthStore((s) => s.clientId);
  const role     = useAuthStore((s) => s.role);
  const name     = useAuthStore((s) => s.name);
  const email    = useAuthStore((s) => s.email);
  const isLoading = useAuthStore((s) => s.isLoading);
  const signOut  = useAuthStore((s) => s.signOut);

  const isAuthenticated = !!user;
  const isOwner         = role === "owner" || role === "super_admin";
  const isSuperAdmin    = role === "super_admin";

  return {
    user,
    userId,
    clientId,
    role,
    name,
    email,
    isLoading,
    isAuthenticated,
    isOwner,
    isSuperAdmin,
    signOut,
  };
}
